<template>
    <el-table
            :data="propsTableData"
            style="width: 100%"
            class="table-wrap ">

        <el-table-column
                prop="hasAtta"
                width="30"
                align="center">
            <template slot-scope="scope">
                <span v-show="scope.row.hasAtta==true" >
                            <svg class="icon" aria-hidden="true" style="font-size:24px;color:#888888;">
                                <use xlink:href="#icon-biaoqianshuqianhuixingzhen"></use>
                            </svg>
                </span>
                <span v-show="scope.row.hasAtta==false"></span>
            </template>
        </el-table-column>
        <el-table-column
                prop=""
                label="状态"
                width="80"
                align="center"
                show-overflow-tooltip>
            <template slot-scope="scope">
                <span>待会诊</span>
            </template>
        </el-table-column>
        <el-table-column
                prop=""
                label="资料是否就绪"
                class-name=""
                show-overflow-tooltip
                align="center">
            <template slot-scope="scope">
                <!--<span v-if="scope.row.consultGroupNo.charAt(0)=='D'" :class="[scope.row.readyStatus?'table-status-green':'table-status-red']">{{ scope.row.readyStatus?'是':'否' }}</span>-->
                <span  :class="[scope.row.readyStatus?'table-status-green':'table-status-red']">{{ scope.row.readyStatus?"是":"否" }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop=""
                show-overflow-tooltip
                label="时间是否安排"
                align="center">
            <template slot-scope="scope">
                <span :class="[scope.row.consultTime?'table-status-green':'table-status-red']">{{ scope.row.consultTime?"是":"否" }}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="consultTime"
                label="安排会诊"
                :formatter="formatUnixConsultTime"
                align="center"
                width="60">
        </el-table-column>
        <!--<el-table-column-->
                <!--prop="consultGroupNo"-->
                <!--label="编号"-->
                <!--align="center"-->
                <!--show-overflow-tooltip>-->
        <!--</el-table-column>-->
        <el-table-column
                prop="consulterName"
                show-overflow-tooltip
                label="患者"
                align="center">
        </el-table-column>
        <!--<el-table-column-->
                <!--prop="consulterGender"-->
                <!--label="性别"-->
                <!--:formatter="sexSelect"-->
                <!--width="50"-->
                <!--align="center">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
                <!--prop="consulterAge"-->
                <!--label="年龄"-->
                <!--width="50"-->
                <!--class="table-column"-->
                <!--align="center">-->
        <!--</el-table-column>-->
        <el-table-column
                prop="initHosName"
                label="申请机构"
                align="center"
                width="100"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="initDeptName"
                label="申请科室"
                align="center"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="initDocName"
                show-overflow-tooltip
                label="申请医生"
                align="center">
        </el-table-column>
        <el-table-column
                prop="createTime"
                label="申请时间"
                :formatter="formatUnix"
                align="center"
                width="60">
        </el-table-column>
        <el-table-column
                prop="consultGroupType"
                show-overflow-tooltip
                label="申请类型"
                align="center">
        </el-table-column>
        <el-table-column
                prop="hopeHosName"
                label="会诊机构"
                show-overflow-tooltip
                align="center">
        </el-table-column>
        <el-table-column
                prop="hopeDeptName"
                label="会诊科室"
                align="center"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="acceptDocName"
                label="会诊专家"
                align="center"
                show-overflow-tooltip>
            <template slot-scope="scope">
                <span>{{scope.row.acceptDocName?scope.row.acceptDocName:scope.row.hopeDocName}}</span>
            </template>
        </el-table-column>
        <el-table-column
                prop="operation"
                label=" 操作"
                align="center"
                inline-template
                show-overflow-tooltip
                width="180">
            <div class="table-btn-wrap">
                <el-button
                        size="small"
                        @click="linkToView($index, row)"
                        class="table-btn ghost-btn">
                    会诊单
                </el-button>
                <el-button
                        size="small"
                        @click="linkToDeal($index, row)"
                        class="table-btn ghost-btn">
                    详情
                </el-button>
            </div>
        </el-table-column>
    </el-table>
</template>
<style>

</style>
<script>
    import { Table,Button,TableColumn, Tooltip } from "element-ui";
    import { formatUnixTime } from "../../utils/DateFormat.js"
    import Vue from "vue";
    Vue.use(Table);
    Vue.use(Button);
    Vue.use(TableColumn);
    Vue.use(Tooltip);
    export default{
        data:function(){
            return{
               activeNo:"1",
            }
        },
        props: ["propsTableData"],
        components:{

        },
        mounted:function(){

        },
        methods: {
            formatUnix: function(row, column){//格式化时间格式
                if(row.createTime){
                    return formatUnixTime(row.createTime, "MM-dd HH:mm");
                }
            },
            formatUnixConsultTime: function (row, column) {//格式化会诊时间
                if(row.consultTime){
                    return formatUnixTime(row.consultTime, "MM-dd HH:mm");
                }else {
                    return "";
                }
            },
            sexSelect: function(row, column){//根据服务器获取到的M或者其他显示男或女
                return (row.consulterGender =="M"?"男":"女");
            },
            formatModifyUnix: function(row, column){//格式化最后处理时间格式
                if(row.modifyTime){
                    return formatUnixTime(row.modifyTime, "MM-dd HH:mm");
                }
            },
            linkToView: function($index, row){
//                this.$router.push({ name: "remoteSheet", params: { consultId: row.consultId }} );
                this.$router.push({ name: "printRemoteSheet", params: { consultId: row.id ,printDetail:row}} );
            },
            linkToDeal: function($index, row){
                switch (row.consultStatus){
                    case 'NEEDCOMMENT':
                    case 'FINSH':
                        this.$router.push({ name: "remoteEvaluate", params: { consultId: row.id }} );
                        break;
                    case 'CANCEL':
                        this.$router.push({ name: "remoteReject", params: { consultId: row.id }} );
                        break;
                    default:
                        if(JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosName.indexOf("宁海")>=0){
                            this.$router.push({ name: "remoteToDeal", params: { consultId: row.id }} );
                        }else{
                            this.$router.push({ name: "remoteEntry", params: { consultId: row.id }} );
                        }
                        break;
                }
            }
        }
    }
</script>
